import { render } from "./OfficeLetters.vue?vue&type=template&id=3ea8f6c7&scoped=true"
import script from "./OfficeLetters.vue?vue&type=script&lang=js"
export * from "./OfficeLetters.vue?vue&type=script&lang=js"

import "./OfficeLetters.vue?vue&type=style&index=0&id=3ea8f6c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea8f6c7"]])

export default __exports__